import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockSolutionFinderFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: a feature block, not on the critical
 * rendering path. Also the only consumer of xstate (~15kB gzip).
 */
export const solutionFinderBlockConfig = {
  name: 'outer-block-solution-finder',
  component: defineAsyncComponent(() => import('./CmsSolutionFinderBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./SolutionFinder.vue')),
  fields: blockSolutionFinderFields,
} satisfies ModularBlockConfig;
